import { EventBusKey } from '@vueuse/core'

/**
 * Threat intelligence configurator - dashboard page
 */
export const createdConfiguratorSuccessfully: EventBusKey<Recordable> = Symbol(
  'configurator-created-successfully',
)

/**
 * For Knowledge Base page category create edit
 */
export const processKnowledgeBaseCategorySuccessfully: EventBusKey<Recordable> = Symbol(
  'knowledge-base-category-process-successfully',
)

/**
 * For Ransompedia -Analyst page edit process
 */
export const processRansompediaVictimUpdateSuccessfully: EventBusKey<Recordable> = Symbol(
  'ransompedia-victim-update-process-successfully',
)

/**
 * For Draft Incident page category create edit
 */
export const createdDraftIncidentSuccessfully: EventBusKey<Recordable> = Symbol(
  'created-draft-incident-successfully',
)

/**
 * For Organization switcher used
 */
export const switchedOrganizationSuccessfully: EventBusKey<Recordable> = Symbol(
  'switched-organization-successfully',
)

/**
 * Start File Upload Process
 */
export const startFileUploadProcess: EventBusKey<Recordable> = Symbol(
  'start-file-upload-process',
)

/**
 * End File Upload Process
 */
export const endFileUploadProcess: EventBusKey<Recordable> = Symbol(
  'end-file-upload-process',
)

/**
 * For ace editor value changes
 */
export const aceEditorValueChange: EventBusKey<Recordable> = Symbol(
  'ace-editor-value-change',
)

/**
 * For suppress bulk operation success
 */
export const deSelectAllRows: EventBusKey<Recordable> = Symbol('de-select-all-rows')

/**
 * For Social Media Ads page Advertisement confirm or decline
 */
export const changeStatusAdSuccessfully: EventBusKey<Recordable> = Symbol(
  'change-status-ad-successfully',
)

/**
 * For Router Modal close event
 */
export const routerModalClosed: EventBusKey<Recordable> = Symbol('router-modal-closed')
